import React from 'react';
import {
  Navigate,
} from 'react-router-dom';
import PCCSettingsForm from 'views/EMR/Settings/PCC/PCCSettingsForm';
import useEMRAccess from 'views/EMR/hooks/useEMRAccess';
import {
  usePCCAvailability,
} from 'views/EMR/hooks/pcc';

export default function PCCSettings() {
  const {
    defaultSettingsPath,
    isPCCActionAvailable,
  } = useEMRAccess();
  const {
    isLoading,
    isPCCAvailable,
  } = usePCCAvailability();
  const shouldRedirect = !isPCCActionAvailable || (!isLoading && !isPCCAvailable);

  return shouldRedirect ? (
    <Navigate to={defaultSettingsPath} replace />
  ) : (
    <PCCSettingsForm className="h-full w-full" />
  );
}
